"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const useBilling_1 = tslib_1.__importDefault(require("./useBilling/useBilling"));
const keyFactory_1 = require("../keyFactory");
/** @deprecated, se debería usar useAvaibleDoctors, sin embargo no hace ninguno de los filtros sobre el array de doctores, eso se debe implementar.
 * Cuando se deje de usar este hook, va a ser eliminado.
 */
function useDoctors(firestore, { especialidad, OS, type, onlyOS }, userCountry, options, queryOptions) {
    const refDoctors = (0, firestore_2.collection)(firestore, "providers/");
    let queryDoctors;
    /** Si tiene especialidad, hago una query con ella, sino, no. */
    /** Si tiene especialidad retorna filtered docs*/
    if (especialidad) {
        queryDoctors = (0, firestore_2.query)(refDoctors, (0, firestore_2.where)("services.MEDICO", "array-contains", type), (0, firestore_2.where)("matricula_especialidad", "==", especialidad), (0, firestore_2.where)("enable", "==", true));
    }
    else {
        queryDoctors = (0, firestore_2.query)(refDoctors, (0, firestore_2.where)("services.MEDICO", "array-contains", type));
    }
    const billing = (0, useBilling_1.default)(firestore);
    const select = (doctors) => {
        /**
       * Les agrrego campo billing a los docs si tienen.
       */
        doctors = doctors.reduce((accum, provider) => {
            const providerBillingById = billing?.data?.flat().filter((billing) => (billing?.uid === provider.uid));
            if (providerBillingById) {
                return [...accum, { ...provider, billing: providerBillingById }];
            }
            else {
                return [...accum, provider];
            }
        }, []);
        /**
       * No puedo añadir otro where de array porque Firebase lo limita
       * Así que hago un filter sobre los datos para limitar por obra social.
       *
       * @param doctors
       */
        if (doctors) {
            const doctorsByCountry = doctors.filter((doctor) => {
                if (Array.isArray(doctor?.country)) {
                    return doctor.country.some((country) => country === userCountry);
                }
            });
            const enabledDoctors = doctorsByCountry.filter((doc) => doc.enable === true);
            const filteredDoctors = enabledDoctors.filter((doctor) => {
                // tiene social work?
                if (doctor?.social_work) {
                    if (OS) {
                        if (OS?.includes("IOMA") && type === "consultorio") {
                            return (doctor.social_work.includes("UMA") ||
                                doctor.social_work.includes(OS) ||
                                doctor.social_work.includes("EMERGENCIAS") // Lo pidio Francisco Massimino, pasa que si tienen IOMA tiene que salirles los docs de Emergencias.
                            );
                        }
                        if (onlyOS) {
                            return doctor.social_work.includes(OS);
                        }
                        else {
                            return (doctor.social_work.includes("UMA") ||
                                doctor.social_work.includes(OS));
                        }
                    }
                    return doctor.social_work?.includes("UMA");
                }
            });
            if (filteredDoctors.length > 0) {
                /**
                 * Añado showPrice a cada doctor, si se incluye la obra social o el tipo es consultorio
                 * es true.
                 */
                return filteredDoctors.map((doctor) => {
                    return {
                        ...doctor,
                        showPrice: !doctor.social_work.includes(OS ?? "nop") || type === "consultorio",
                    };
                });
            }
            return [];
        }
        return [];
    };
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "providers",
        path: "providers/"
    }, [especialidad, OS, type]), queryDoctors, options, {
        select: select,
        ...queryOptions,
    });
}
exports.default = useDoctors;
